import _regeneratorRuntime from "C:\\Users\\nanma\\Documents\\GitHub\\star\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\Users\\nanma\\Documents\\GitHub\\star\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _construct from "C:\\Users\\nanma\\Documents\\GitHub\\star\\node_modules\\@babel\\runtime/helpers/esm/construct";
import _toConsumableArray from "C:\\Users\\nanma\\Documents\\GitHub\\star\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _taggedTemplateLiteral from "C:\\Users\\nanma\\Documents\\GitHub\\star\\node_modules\\@babel\\runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["## reusable3dCanvas\n\nThe canvas is highly configurable; pass any configuration changes\nas the third argument.  Until I add more examples, just\nread the code below to explore the possibilities.\n\nYes, the configuration names and structure can be improved upon.\n\nI'd like to find a way to make ```reusable3dCanvas```\nand ```reactive3dCanvas``` less opinionated about the\nlighting, camera, and controls.  Send your suggestions!\n\nIn particular, I loathe the ```THREE.OrbitControls```,\nbut ```THREE.TrackballControls``` is not well-behaved\nwhen there are multiple canvases on a page; I haven't figured\nout how to make it respond only to mouse events one canvas at a time.\n"], ["## reusable3dCanvas\n\nThe canvas is highly configurable; pass any configuration changes\nas the third argument.  Until I add more examples, just\nread the code below to explore the possibilities.\n\nYes, the configuration names and structure can be improved upon.\n\nI'd like to find a way to make \\`\\`\\`reusable3dCanvas\\`\\`\\`\nand \\`\\`\\`reactive3dCanvas\\`\\`\\` less opinionated about the\nlighting, camera, and controls.  Send your suggestions!\n\nIn particular, I loathe the \\`\\`\\`THREE.OrbitControls\\`\\`\\`,\nbut \\`\\`\\`THREE.TrackballControls\\`\\`\\` is not well-behaved\nwhen there are multiple canvases on a page; I haven't figured\nout how to make it respond only to mouse events one canvas at a time.\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\nThe entire mesh is being replaced as you change the color,\nbut the camera remains unchanged.\n\nAt the moment, ```reusable3dCanvas``` *only* supports wholesale mesh changes.\nFor example, changing the background color with the color picker below\nwill not update the scene; you must re-run the main cell above to\nrender with the new background color.\n"], ["\nThe entire mesh is being replaced as you change the color,\nbut the camera remains unchanged.\n\nAt the moment, \\`\\`\\`reusable3dCanvas\\`\\`\\` *only* supports wholesale mesh changes.\nFor example, changing the background color with the color picker below\nwill not update the scene; you must re-run the main cell above to\nrender with the new background color.\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\nRotate, pan, or zoom with your mouse on the scene above.\nThen click on the first color picker below, to change the color of the cube.\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\nIf you create multiple WebGL canvases in a single Observable notebook,\nand those notebook cells get re-evaluated often, you'll find that\nyou can quickly run out of WebGL contexts.\nI had this problem with [one of my notebooks][3].\n(It is possible that I could have fixed this by disposing of the contexts correctly; I haven't looked into that.)\n\nThere are also sound functional reasons to reuse an existing WebGL context, as illustrated in\nmy [Mutating WebGL Uniforms][2] notebook, itself a fork of a fork.  Mike Bostock discusses the general problem in [this forum thread][1].\n\nOne obvious use-case is to update the mesh being rendered, without losing the camera\nposition and orientation, as seen below.\n\n[1]:https://talk.observablehq.com/t/slider-changes-re-creating-webgl-context/202/4\n[2]:https://beta.observablehq.com/@vorth/mutating-webgl-uniforms\n[3]:https://beta.observablehq.com/@vorth/exploring-4d-quaternion-rotations\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["# Reusable Three.js Canvas"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// https://observablehq.com/@vorth/reusable-three-js-canvas@154
import define1 from "../@jashkenas/inputs.js";
export default function define(runtime, observer) {
  var main = runtime.module();
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject());
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject2());
  });
  main.variable(observer()).define(["reusable3dCanvas", "cube", "background"], function (reusable3dCanvas, cube, background) {
    return reusable3dCanvas(this, cube, {
      background: background,
      camera: {
        aspect: 2,
        position: [3, 4, 5]
      }
    });
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject3());
  });
  main.variable(observer("viewof cubeColor")).define("viewof cubeColor", ["color"], function (color) {
    return color({
      value: '#8278d1'
    });
  });
  main.variable(observer("cubeColor")).define("cubeColor", ["Generators", "viewof cubeColor"], function (G, _) {
    return G.input(_);
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject4());
  });
  main.variable(observer("viewof background")).define("viewof background", ["color"], function (color) {
    return color({
      value: '#9cd3d7'
    });
  });
  main.variable(observer("background")).define("background", ["Generators", "viewof background"], function (G, _) {
    return G.input(_);
  });
  main.variable(observer("cube")).define("cube", ["THREE", "cubeColor"], function (THREE, cubeColor) {
    return new THREE.Mesh(new THREE.CubeGeometry(), new THREE.MeshLambertMaterial({
      color: cubeColor
    }));
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject5());
  });
  main.variable(observer("reusable3dCanvas")).define("reusable3dCanvas", ["reactive3dCanvas"], function (reactive3dCanvas) {
    return function (existingCanvas, mesh) {
      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (existingCanvas && existingCanvas.replaceMesh) {
        existingCanvas.replaceMesh(mesh);
        return existingCanvas;
      } else {
        return reactive3dCanvas(mesh, config);
      }
    };
  });
  main.variable(observer("reactive3dCanvas")).define("reactive3dCanvas", ["lightedCamera", "perspectiveCamera", "scene", "renderer", "addOrbitControl", "THREE"], function (lightedCamera, perspectiveCamera, scene, renderer, addOrbitControl, THREE) {
    return function (mesh) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _config$orbitControl = config.orbitControl,
          orbitControl = _config$orbitControl === void 0 ? true : _config$orbitControl;
      var camera = lightedCamera(perspectiveCamera(config.camera), config.lights);
      var s = scene(mesh, camera, config);
      var r = renderer(config);
      var control = null;
      if (orbitControl) // we want to toggle this off sometimes, to avoid the OrbitControls import bug
        control = addOrbitControl(r, s, camera, config.camera); // enable later scene manipulation

      r.domElement.scene = s;

      r.domElement.render = function () {
        return r.render(s, camera);
      };

      r.domElement.replaceMesh = function (mesh) {
        // this will only apply in a reusable canvas
        s.remove(s.replaceableMesh);
        s.add(mesh);
        s.replaceableMesh = mesh;
        r.render(s, camera);
      };

      r.domElement.adjustCamera = function (position, lookAt, up) {
        var _camera$position;

        camera.lookAt(_construct(THREE.Vector3, _toConsumableArray(lookAt))); // This seems to be disabled by OrbitControls

        control.target = _construct(THREE.Vector3, _toConsumableArray(lookAt));
        camera.up = _construct(THREE.Vector3, _toConsumableArray(up));

        (_camera$position = camera.position).set.apply(_camera$position, _toConsumableArray(position));

        control.update();
        r.render(s, camera);
      };

      r.render(s, camera);
      return r.domElement;
    };
  });
  main.variable(observer("renderer")).define("renderer", ["width", "THREE"], function (width, THREE) {
    return function () {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _config$renderWidth = config.renderWidth,
          renderWidth = _config$renderWidth === void 0 ? width : _config$renderWidth,
          _config$camera = config.camera,
          camera = _config$camera === void 0 ? {} : _config$camera;
      var _camera$aspect = camera.aspect,
          aspect = _camera$aspect === void 0 ? 2 : _camera$aspect;
      var renderer = new THREE.WebGLRenderer({
        antialias: true
      });
      renderer.setPixelRatio(window.devicePixelRatio);
      renderer.setSize(renderWidth, renderWidth / aspect);
      return renderer;
    };
  });
  main.variable(observer("perspectiveCamera")).define("perspectiveCamera", ["THREE"], function (THREE) {
    return function () {
      var _camera$position2;

      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _config$fov = config.fov,
          fov = _config$fov === void 0 ? 30 : _config$fov,
          _config$aspect = config.aspect,
          aspect = _config$aspect === void 0 ? 2 : _config$aspect,
          _config$near = config.near,
          near = _config$near === void 0 ? 1 : _config$near,
          _config$far = config.far,
          far = _config$far === void 0 ? 4000 : _config$far,
          _config$position = config.position,
          position = _config$position === void 0 ? [0, 0, 500] : _config$position,
          _config$up = config.up,
          up = _config$up === void 0 ? [0, 0, 1] : _config$up,
          _config$lookAt = config.lookAt,
          lookAt = _config$lookAt === void 0 ? [0, 0, 0] : _config$lookAt;
      console.log(lookAt);
      var camera = new THREE.PerspectiveCamera(fov, aspect, near, far);
      camera.lookAt(_construct(THREE.Vector3, _toConsumableArray(lookAt))); // This seems to be disabled by OrbitControls

      camera.up = _construct(THREE.Vector3, _toConsumableArray(up));

      (_camera$position2 = camera.position).set.apply(_camera$position2, _toConsumableArray(position));

      return camera;
    };
  });
  main.variable(observer("lightedCamera")).define("lightedCamera", ["THREE"], function (THREE) {
    return function (camera) {
      var _spotLight$position;

      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _config$spot = config.spot,
          spot = _config$spot === void 0 ? {
        color: 0x888888,
        intensity: 0.4,
        position: [200, 500, 0]
      } : _config$spot;
      var spotLight = new THREE.SpotLight(spot.color, spot.intensity);

      (_spotLight$position = spotLight.position).set.apply(_spotLight$position, _toConsumableArray(spot.position));

      camera.add(spotLight);
      var _config$ambient = config.ambient,
          ambient = _config$ambient === void 0 ? {
        color: 0x444444,
        intensity: 0.8
      } : _config$ambient;
      camera.add(new THREE.AmbientLight(ambient.color, ambient.intensity));
      camera.add(new THREE.HemisphereLight(0xefede8, 0x727248, .6));
      return camera;
    };
  });
  main.variable(observer("scene")).define("scene", ["THREE"], function (THREE) {
    return function (mesh, camera) {
      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var scene = new THREE.Scene();
      var _config$background = config.background,
          background = _config$background === void 0 ? 0xaaccff : _config$background;
      scene.background = new THREE.Color(background);
      scene.add(camera);
      scene.add(mesh);
      scene.replaceableMesh = mesh;
      return scene;
    };
  });
  main.variable(observer("addOrbitControl")).define("addOrbitControl", ["THREE"], function (THREE) {
    return function (renderer, scene, camera) {
      var config = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var _config$lookAt2 = config.lookAt,
          lookAt = _config$lookAt2 === void 0 ? [0, 0, 0] : _config$lookAt2;
      var control = new THREE.OrbitControls(camera, renderer.domElement);
      control.target = _construct(THREE.Vector3, _toConsumableArray(lookAt)); // controls .rotateSpeed = 5;
      // controls .zoomSpeed = 2.5;

      control.addEventListener("change", function () {
        renderer.render(scene, camera);
      });

      function animate() {
        requestAnimationFrame(animate);
        control.update();
      }

      animate();
      return control;
    };
  });
  main.variable(observer("THREE")).define("THREE", ["require"],
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(require) {
      var THREE;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return require("three@0.96/build/three.min.js");

            case 2:
              THREE = window.THREE = _context.sent;
              _context.next = 5;
              return require("three@0.96/examples/js/controls/OrbitControls.js").catch(function () {});

            case 5:
              return _context.abrupt("return", THREE);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
  var child1 = runtime.module(define1);
  main.import("color", child1);
  return main;
}